import ExportModal, { ExportModalProps } from './ExportModal'
import { HOSPITAL_COLUMNS } from 'components/DataExpansionComponents/Hospitals/hospitalColumnsInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'

export default function HospitalExportModal(props: ExportModalProps) {
  const hospitalColumnHelper = createExportColumnHelper({
    columns: HOSPITAL_COLUMNS,
  })

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        hospitalColumnHelper.retrieveColumn('hospital_name'),
        hospitalColumnHelper.retrieveColumn('street_addr'),
        hospitalColumnHelper.retrieveColumn('city'),
        hospitalColumnHelper.retrieveColumn('state'),
        hospitalColumnHelper.retrieveColumn('zip_code'),
        hospitalColumnHelper.retrieveColumn('domain'),
        hospitalColumnHelper.retrieveColumn('website_url'),
      ],
    },
    {
      title: 'Hospital Insights',
      elements: [
        hospitalColumnHelper.retrieveColumn('total_hospital_beds'),
        hospitalColumnHelper.retrieveColumn('total_hospital_days'),
        hospitalColumnHelper.retrieveColumn('cafeteria'),
        hospitalColumnHelper.retrieveColumn('dietary'),
        hospitalColumnHelper.retrieveColumn('dietary_under_contract'),
        hospitalColumnHelper.retrieveColumn('meals_per_day'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  return (
    <ExportModal
      title="Select Columns for Hospitals Download"
      subTitle="Download up to 10,000 hospitals at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Hospitals"
      columns={columns}
      {...props}
    />
  )
}
